import { AT_DEPENDENCIES_REQUESTS_STATE_SET, IDependenciesRequestsStateSetAction } from './types';
import { IDependenciesRequestsState } from '../reducers/types';

export const dependenciesRequestsStateSetAction = (
    dependencies: IDependenciesRequestsState
): IDependenciesRequestsStateSetAction => ({
    type: AT_DEPENDENCIES_REQUESTS_STATE_SET,
    dependencies
});
